module.exports = __webpack_public_path__ + "img/chess-queen-piece.df085997.svg";